import { render, staticRenderFns } from "./call-center.vue?vue&type=template&id=60994958&scoped=true&"
import script from "./call-center.vue?vue&type=script&lang=js&"
export * from "./call-center.vue?vue&type=script&lang=js&"
import style0 from "./call-center.vue?vue&type=style&index=0&id=60994958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60994958",
  null
  
)

export default component.exports